// React
import React from "react";

// External libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal
import {getDataTestId} from "../functions/data-test-ids";

/**
 * The icon shown at the START of an input, before the value.
 *
 * `Title` is optional and decides whether the icon is DECORATIVE or MEANINGFUL. Without one the icon is
 * left unlabelled, which is right for the usual case - an envelope beside an email field repeats what the
 * field's own label already says. With one, the icon is carrying information of its own (a green tick that
 * is the only confirmation an action succeeded, say), so it is exposed as an image with that text as its
 * accessible name and its tooltip. An icon whose meaning is in its shape and colour alone reaches nobody
 * who cannot see it.
 */
function InputIcon(props) {
    if (!props.Icon) {
        return null;
    }

    return (
        <div
            className="eone-ui-input-string-icon"
            role={props.Title ? "img" : undefined}
            aria-label={props.Title}
            title={props.Title}>
            <FontAwesomeIcon fixedWidth={true} icon={props.Icon} data-testid={getDataTestId(props.DataTestId, "icon")}/>
        </div>
    );
}

export { InputIcon };